module.exports = __webpack_public_path__ + "static/img/smallCard.e6a33192.png";